export default {
  // common 부분
  login: "/signIn",
  logout: "/signOut",
  register: "/signUp",
  duplicateEmail: "/duplicateEmail",
  getProfile: "/getProfile",
  editProfile: "/editProfile",
  removeAccount: "/removeAccount",

  //dev
  createApp: "/createApp",
  appList: "/appList",
  appDetail: "/appDetail",
  appRemove: "/appRemove",
  appVersions: "/appVersions",
  appClone: "/appClone",
  selectApi: "/selectApi",
  insertApi: "/insertApi",
  updateApi: "/updateApi",
  updateApiSchema: "/updateApiSchema",
  selectOneApi: "/selectOneApi",
  deleteApi: "/deleteApi",
  selectApiSchema: "/selectApiSchema",
  configSchema: "/configSchema",
  deleteApiSchema: "/deleteApiSchema",
  selectOneRequest: "/selectOneRequest",
  resetAuth: "/resetAuth",
  addAuth: "/addAuth",

  // user
  getApiList: "/getApiList",
  createWorkflow: "/createWorkflow",
  getWorkflowList: "/getWorkflowList",
  deleteWorkflow: "/deleteWorkflow",
  updateWorkflow: "/updateWorkflow",
  getWorkflowDetail: "/getWorkflowDetail",
  createGroup: "/createGroup",
  getGroupList: "/getGroupList",
  deleteGroup: "/deleteGroup",
  updateGroup: "/updateGroup",
  getAppDetail: "/getAppDetail",
  getApiDetail: "/getApiDetail",
  getAllApiList: "/getAllApiList",

  //통신
  sendTest: "/connectApi",
};
